import "../style/home.css"
import { useContext, useEffect } from "react";
import { AppContext } from "../context/AppContext";
import { useNavigate } from "react-router-dom";
import { SettingDisplay } from "../components/SettingDisplay";
import { HomeButtons } from "../components/HomeButtons";
import buffering from "../media/buffering.gif";

export function Home() {
    const appContext = useContext(AppContext);
    const navigate = useNavigate();
    const categories = appContext.categoryLookup;

    const start = ()=>{
        appContext.getQuestions("startup");      
    }

    useEffect(()=>{
        if (appContext.questions === null) {
            //appContext.getQuestions("startup");
            appContext.getCategoryLookup();
        }
    // eslint-disable-next-line
    }, [])

    const settings = () => {
        navigate("/settings");
    }

    const getCategoryById = (id) => {
        for (let i = 0; i < categories.length; i++) {
            // eslint-disable-next-line
            if (categories[i].id == id) {
                //console.log(categories[i].name);
                return categories[i].name;
            }
        }
    }

    return(
        <div className="home">
            <div className="top-half">
                <div className="title-bcg">
                    <span className="quiz-title">
                        QUIZ
                    </span>
                    <div className="icon-container">
                    <img 
                        src={require("../media/any-category.png")} 
                        alt="question mark"
                        className="title-icon"/>
                    </div>
                </div>
                <div className="custom-settings" id="custom-settings">
                    {appContext.settings.amount !== "10" ? <SettingDisplay value={appContext.settings.amount} text=" questions"/> : <span></span>}
                    {// eslint-disable-next-line 
                    appContext.settings.category != 0 ? <SettingDisplay value={getCategoryById(appContext.settings.category)} text=""/> : <span></span>}
                    {appContext.settings.difficulty !== "any" ? <SettingDisplay value={appContext.settings.difficulty} text=""/> : <span></span>}
                </div>
            </div>
            <div className="bottom-half">
                {/* {appContext.questions !== null ? <HomeButtons start={start} settings={settings}/> : <img src={buffering} alt="buffering"/>} */}
                <HomeButtons start={start} settings={settings}/>
                <span className="footer">Powered by Open Trivia Database</span>
            </div>
        </div>
    );
}